module.exports = __webpack_public_path__ + "static/1-2a9063340e219954cd9d4f2e4bba0fd4.png";